// src/features/home/components/HomeCard.jsx
import React from 'react';
import { Box, Card, CardContent, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Shared shell for every homepage panel so headers, padding and borders line up.
 * `large` is for the main-column cards; the right-hand widgets use the compact size.
 */
export default function HomeCard({ icon, title, action, accentColor, large = false, children }) {
  const theme = useTheme();
  const padding = large ? 4 : 3;

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: `1px solid ${accentColor ? alpha(accentColor, 0.35) : theme.palette.divider}`,
        bgcolor: 'background.paper',
        overflow: 'visible',
      }}
    >
      <CardContent sx={{ p: padding, '&:last-child': { pb: padding } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: large ? 3 : 2 }}>
          <Box sx={{ color: accentColor ?? 'primary.main', display: 'flex', flexShrink: 0 }}>
            {icon}
          </Box>
          <Typography variant={large ? 'h5' : 'subtitle1'} fontWeight={700} sx={{ flex: 1 }}>
            {title}
          </Typography>
          {action}
        </Box>
        {children}
      </CardContent>
    </Card>
  );
}
